export const CREATE_TASK = 'CREATE_TASK';
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS';

export const GET_TASKS = 'GET_TASKS';
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS';

export const GET_TASK_BY_ID = 'GET_TASK_BY_ID';
export const GET_TASK_BY_ID_SUCCESS = 'GET_TASK_BY_ID_SUCCESS';

export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';

export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';

export const BULK_UPDATE_TASK_STATUS = 'BULK_UPDATE_TASK_STATUS';
export const BULK_ASSIGN_TASK = 'BULK_ASSIGN_TASK';
export const BULK_DELETE_TASKS = 'BULK_DELETE_TASKS';

export const CREATE_TASK_COMMENT = 'CREATE_TASK_COMMENT';
export const CREATE_TASK_COMMENT_SUCCESS = 'CREATE_TASK_COMMENT_SUCCESS';

export const GET_TASK_COMMENTS = 'GET_TASK_COMMENTS';
export const GET_TASK_COMMENTS_SUCCESS = 'GET_TASK_COMMENTS_SUCCESS';

export const DELETE_TASK_COMMENT = 'DELETE_TASK_COMMENT';
